import React from 'react';
import './App.css';
import DesktopLayout from './layout/Desktop/DesktopLayout';

function App() {
    return (
        <div className="App">
            <DesktopLayout />
        </div>
    );
}

export default App;
